import { SourceType } from 'module/api/filter/types';
import { useEmailFieldsAsFilterableField } from 'helpers/fields/email-fields/fields';
import { EmailDetailsSectionComponentProps } from './types';
import { meetingBlockResponseToLookup } from '../../shared/response-renderer-utils';
import { SharedDetailBlockGeneratedSection } from '../shared-detail-blocks/generated-section';

export const EmailDetailsGeneratedSection = ({
  node,
}: EmailDetailsSectionComponentProps) => {
  const { fields: emailFields, loading: isLoading } =
    useEmailFieldsAsFilterableField();

  return (
    <SharedDetailBlockGeneratedSection
      node={node}
      sourceType={SourceType.Email}
      useFieldsHook={() => ({ fields: emailFields, loading: isLoading })}
      defaultTitleKey="rich_text_editor_sections_email_details"
      titlePlaceholderKey="rich_text_editor_sections_email_details_title_placeholder"
      fieldLabelKey="grouped_filter.email"
      responseToLookupFunction={meetingBlockResponseToLookup}
    />
  );
};
